import StatusColumn from './StatusColumn';

export default StatusColumn;
